import { eTransactionType } from '../eTransactionType';
import {
  convertIFlatEndorsementFeeResponseToIFlatEndorsementFeeData,
  IFlatEndorsementFeeData,
  IFlatEndorsementFeeResponse,
} from './IFlatEndorsementFee';

export interface IFlatEndorsementConfigResponse {
  transactionTypes: eTransactionType[];
  endorsements: IFlatEndorsementFeeResponse[];
}

export interface IFlatEndorsementConfigData {
  transactionTypes: eTransactionType[];
  endorsements: IFlatEndorsementFeeData[];
}

export const convertIFlatEndorsementConfigResponseToIFlatEndorsementConfigData = ({
  endorsements,
  ...rest
}: IFlatEndorsementConfigResponse): IFlatEndorsementConfigData => ({
  endorsements: endorsements.map(convertIFlatEndorsementFeeResponseToIFlatEndorsementFeeData),
  ...rest,
});
